export default __webpack_public_path__ + "static/media/h100-2.feb7c5c0.png";